import React from "react";
import { ParamsStr } from "../../lib/InterfaceCalculation";
import { AUTH } from "../../utils/Req";
import $ from "jquery";

class InputPhone extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      country: "",
      code: 0,
      items: null,
      currentIndex: 0
      //   showAllCountry: false
    };

    this.chooseCountryHandler = this.chooseCountryHandler.bind(this);
  }

  componentDidMount() {
    const { changeCountryHandler } = this.props;
    const that = this;
    //   获取所有的区号
    const req = new Request(
      `${AUTH}/country_codes?phone=${this.state.phone}${ParamsStr()}`,
      { method: "GET" }
    );
    fetch(req)
      .then(res => res.json())
      .then(data => {
        if (data.code === 200) {
          that.setState({
            country: data.items[0].country,
            code: data.items[0].code,
            items: data.items
          });

          changeCountryHandler(data.items[0]);
        }
      });
  }

  //   选择国家的处理事件
  //  参数：value: 点击选择当前的； index: 当前的索引值， flag： 上一个还是下一个
  chooseCountryHandler(value, index, flag) {
    const { changeCountryHandler } = this.props;

    this.setState({
      code: value.code,
      country: value.country,
      currentIndex: index
    });

    // 修改正则匹配
    changeCountryHandler(value);
  }

  // 修改索引值
  changeCountryIndexHandler(flag) {
    const { items, currentIndex } = this.state;
    let index = currentIndex;
    if (flag < 0) {
      index -= 1;
    } else {
      index += 1;
    }

    if (index < 0) {
      index = items.length - 1;
    }
    if (index >= items.length) {
      index = 0;
    }

    const value = items[index];
    this.chooseCountryHandler(value, index);
  }

  render() {
    const {
      input,
      onChange,
      onClick,
      msgOne,
      value,
      onBlur,
      changeStateHandler,
      showAllCountry
    } = this.props;
    const { items, country, code } = this.state;
    return (
      <div className={`input-container ${input.className}`}>
        {showAllCountry ? <div className="country-container-close" onClick={() => {
          this.setState({
            showAllCountry: false
          })
        }} /> : null}
        <div className="choose-country">
          <div className="country-name">{country}</div> +{code ? code : 86}
          <div
            className="country-prev"
            onClick={() => {
              this.changeCountryIndexHandler(-1);
            }}
          />
          <div
            className="country-next"
            onClick={() => {
              this.changeCountryIndexHandler(1);
            }}
          />
          {showAllCountry ? (
            <div className="country-container-no-mean">
              <div id="country-container" className="country-container">

                {/* 遍历 items */}
                {items &&
                  items.map((value, index) => (
                    <div
                      className={value.country === country ? "active item-container" : "item-container"}
                    >
                      <div
                        key={index}
                        className={value.country === country ? "active" : ""}
                        onClick={() => {
                          this.chooseCountryHandler(value, index);
                        }}
                      >
                        {value.country}{" "}
                        <span className="country-code">
                          {" "}
                          &nbsp;&nbsp;+{value.code}
                        </span>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          ) : null}
        </div>
        <input
          placeholder={input.placeholder}
          //   className={input.className}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          name={input.name}
          maxLength={11}
          style={{ width: "60%" }}
        />
        {value && <div className="delete" onClick={onClick} />}
        {msgOne && (
          <div className="msg">
            {msgOne.indexOf("0") === 0 ? msgOne.slice(1) : msgOne}
            {msgOne.indexOf("0") === 0 && (
              <span
                style={{ textDecoration: "underline", cursor: "pointer" }}
                onClick={() => {
                  changeStateHandler("#/login?id=2");
                }}
              >
                验证码登录>>
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default InputPhone;



// WEBPACK FOOTER //
// ./src/components/login/InputPhone.js